import React from "react";
import ChatComponent from "../../../../Components/ChatComponent/ChatComponent";
import ChatInput from "../../../../Components/ChatInput";

/**
 * SurveyChat - Specialized chat component for survey view
 * @param {Object} props - Component props
 * @param {Array} props.chatData - Array of chat messages
 * @param {Function} props.onOptionSelected - Handler for option selection
 * @param {boolean} props.isAiLoading - Flag indicating if AI is loading
 * @param {string} props.transcript - Current transcript text
 * @param {string} props.chatChange - Current chat input value
 * @param {Function} props.clearManualData - Function to clear input
 * @param {string} props.lastQuestID - ID of the last question
 * @param {Function} props.handleEnterWithSubmit - Handler for enter key submission
 * @param {Function} props.onEnterDataPicker - Handler for data submission
 * @param {Function} props.afterOnPassData - Callback after data is passed
 * @param {Function} props.changeData - Handler for input changes
 * @param {boolean} props.restrictEnterManualData - Flag to restrict manual data entry
 * @param {boolean} props.isChatProgress - Flag indicating if chat is in progress
 * @param {boolean} props.isChatLoading - Flag indicating if chat is loading
 * @param {boolean} props.hideChatInput - Flag to hide chat input
 * @param {Function} props.loadLatestChatHistory - Function to load latest chat history
 * @param {string} props.chatMaxHeight - Maximum height for chat container
 * @param {React.RefObject} props.clearRef - Ref for clearing input
 * @param {React.RefObject} props.aiChatRef - Ref for chat component
 * @param {React.RefObject} props.inputContainerRef - Ref for input container
 */
const SurveyChat = ({
  chatData,
  onOptionSelected,
  isAiLoading,
  transcript,
  chatChange,
  clearManualData,
  lastQuestID,
  handleEnterWithSubmit,
  onEnterDataPicker,
  afterOnPassData,
  changeData,
  restrictEnterManualData,
  isChatProgress,
  isChatLoading,
  hideChatInput,
  loadLatestChatHistory,
  chatMaxHeight,
  clearRef,
  aiChatRef,
  inputContainerRef,
}) => {
  return (
    <div className="relationship-chat-hero-container-survey">
      <div 
        className="relationShip-chats-isSurvey" 
        style={{ maxHeight: chatMaxHeight }}
      >
        <ChatComponent
          chatArray={chatData}
          onOptionSelected={onOptionSelected}
          isAiLoading={isAiLoading}
          iselements={false}
          isSurvey={true}
          manualEnteredData={chatChange}
          clearManualData={clearManualData}
          lastQuestID={lastQuestID}
          handleEnterWithSubmit={handleEnterWithSubmit}
          aiChatRef={aiChatRef}
        />
      </div>

      {!hideChatInput && (
        <div className="relationship-input-box-cntr">
          <div
            className="relationship-input-cntr added-margin"
            ref={inputContainerRef}
          >
            <div className="rl-input">
              <ChatInput
                onChange={onEnterDataPicker}
                value={transcript}
                afterOnPassData={afterOnPassData}
                changeData={changeData}
                ref={clearRef}
                restrictEnterManualData={restrictEnterManualData}
                isSurvey={true}
                isChatProgress={isChatProgress}
                isChatLoading={isChatLoading}
                loadLatestChatHistory={loadLatestChatHistory}
                showLastChat={false}
                chatPlaceHolder="Write here..."
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SurveyChat;
